import styled, { css } from "styled-components";
import { mediaQueries } from "./mediaQueries.js";

export const ModalButton = styled.button`
  padding: 10px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 2em;
  color: whitesmoke;

  ${(props) =>
        props.color &&
        css`
            background-color: ${props.color};
        `} 

  ${(props) =>
    props.close &&
    css`
      font-size: 3em;
      position: fixed;
      right: 0;
      top: 0;
      margin: 5px;
      padding: 15px 20px;
      display: flex;
      justify-content: center;
      border-radius: 25px;
    `}
`;

export const ModalContainer = styled.div`
  position: fixed;
  background: black;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 777;

  ${(props) =>
        props.color &&
        css`
            border: 5px solid ${props.color};
        `} 

  ${(props) =>
    props.size && props.size === "large"
      ? css`
          width: 98vw;
          height: 98vh;
        `
      : css`
          ${mediaQueries("phone")} {
            width: 90vw;
            height: 65vh;
          }
          ${mediaQueries("tablet")} {
            width: 65vw;
            height: 70vh;
          }
        `}
        /* ${(props) =>
    props.small &&
    css`
      width: 50vw;
      height: 50vh;
      display: flex;
      flex-flow: column-wrap;
    `}

    ${(props) =>
    props.medium &&
    css`
      width: 65vw;
      height: 70vh;
    `}*/
`;
